module.exports = __webpack_public_path__ + "static/img/2airbus2.51993b78.png";